import React from 'react';
import Joi from 'joi';
import PropTypes from 'prop-types';

import AutTable from '../../blocks/aut-grid-table/index';
import Conditional from '../../common/conditional';
import Form from '../../common/form';
import UTInspectionItemForm from './utInspectionItem';

import * as data from '../../../utils/data';
import * as models from '../../../utils/models';

class UTInspectionDataForm extends Form {
	state = {
		data: { items: [] },
		errors: {},
		loading: false,
		progress: 0,
	};

	schema = {
		items: Joi.array()
			.min(1)
			.items(
				Joi.object({
					tmlLocation: Joi.number().positive().required().label('TML Location'),
					description: Joi.string().min(3).required().label('Description'),
					size: Joi.number().min(1).required().label('Size (Inches)'),
					nominal: Joi.number().positive().required().label('Nominal'),
					a: Joi.string().required().label('A'),
					twelveOC: Joi.number().positive().required().label("12'O'c"),
					threeOC: Joi.number().positive().required().label("3'O'c"),
					sixOC: Joi.number().positive().required().label("6'O'c"),
					nineOC: Joi.number().positive().required().label("9'O'c"),
					wtLoss: Joi.number().positive().required().label('%WT.Loss'),
					comments: Joi.string().min(3).required().label('Comments'),
				})
			)
			.required()
			.label('Inspection Items'),
	};

	static propTypes = {
		onProceed: PropTypes.func,
	};

	onAddItem = (item: models.MUTUTInspectionItem) => {
		const data: any = { ...this.state.data };
		data.items = [...data.items];
		data.items.push({ ...item, tmlLocation: data.items.length + 1 });

		this.setState({ data });
	};

	onDeleteItem = (item: models.MUTUTInspectionItem): void => {
		const data = { ...this.state.data };
		data.items = data.items.filter(
			(i: models.MUTUTInspectionItem) => i.tmlLocation !== item.tmlLocation
		);

		this.setState({ data });
	};

	doSubmit = (): void => {
		const props: any = this.props;
		props.onProceed(this.state.data.items);

		this.setState({ data: { items: [] } });
	};

	render() {
		return (
			<React.Fragment>
				<UTInspectionItemForm onAdd={this.onAddItem} />

				<AutTable
					tableColumns={data.getMUTColumns()}
					data={this.state.data.items}
					onDeleteItem={this.onDeleteItem}
				/>

				<Conditional isVisible={this.state.data.items.length > 0}>
					<form autoComplete="off" onSubmit={this.handleSubmit}>
						{this.renderButton('Finish')}
					</form>
				</Conditional>
			</React.Fragment>
		);
	}
}

export default UTInspectionDataForm;
